import React from "react";
import Sidebar from "../../components/commons/Sidebar";
import ProjectTable from "../../components/admin/project/project";

const ProjectsAdminPage = () => {
  return (
    <div className="flex flex-col md:flex-row min-h-screen bg-slate-50">
      <Sidebar />
      <ProjectTable />
    </div>
  );
};

export default ProjectsAdminPage;
